export const FINANCIAL_MANAGER_TYPES = ['manager', 'supervisor'];
export const isFinancialManagerType = (type) => {
    return FINANCIAL_MANAGER_TYPES.includes(type || '');
};
export const isSettleableInstallment = (installment) => {
    return installment.status === 'pending';
};
export const resolveInstallmentBucket = (installment) => {
    if (installment.status === 'paid')
        return 'paid';
    if (installment.status === 'overdue' || installment.is_overdue)
        return 'overdue';
    if (installment.status === 'pending')
        return 'pending';
    return null;
};
export const filterInstallmentsByStatus = (installments, statusFilter) => {
    if (!statusFilter)
        return installments;
    return installments.filter((installment) => resolveInstallmentBucket(installment) === statusFilter);
};
